// Search Function
var predictiveSearchInput = document.getElementById('searchInputField');
var timer;

var offcanvasSearch = document.getElementById('searchResult');
var bsOffcanvas = document.getElementById('searchResult');

if(predictiveSearchInput != null) {
    predictiveSearchInput.addEventListener('input', function(e) {

        clearTimeout(timer);

        if(predictiveSearchInput.value) {
            timer = setTimeout(fetchPredictiveSearch, 500);
        }

        
    });
}

function fetchPredictiveSearch() {
    fetch(`/search/suggest.json?q=${predictiveSearchInput.value}&resources[type]=product`)
    .then(resp => resp.json())
    .then(data => { 
        console.log(data);

        var products = data.resources.results.products;

        document.getElementById('search_results_body').innerHTML = '';

        products.forEach(function(product, index) {
            document.getElementById('search_results_body').innerHTML += `
                <a href="${product.url}">
                    <div class="flex items-start mb-10" style="w-320">
                    <img src="${product.image}" class="w-100">
                    <div class="ml-10">
                        <p class="uppercase mt-0 mb-5">${product.title}</p>
                        <p class="m-0" style="color:#edd100;">$${product.price}</p>
                    </div>
                </div>
                </a>
            `
        });
        bsOffcanvas.classList.add("block");
    });
}

// Currency Change
function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });


  // Sliders

  // Full Width Slider Section

  var swiper = new Swiper (".full-width-slider", {
    lazy: true,
    loop: true,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Featured Quotes Slider Section
  
  var slider = new Swiper ('.featured-quotes-slider', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    effect: 'fade',
    loopedSlides: 5,
});

var thumbs = new Swiper ('.featured-quotes-thumbs', {
    slidesPerView: '2',
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    slideToClickedSlide: true,
    breakpoints: {
        280: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
      },
});

slider.controller.control = thumbs;
thumbs.controller.control = slider

  // Marquee Slider Section

let SwiperTop = new Swiper('.swiper--marquee', {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 6000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView:'auto',
  allowTouchMove: false,
  disableOnInteraction: true,
});

  // Testimonials Slider Section

let swiperTestimonials = new Swiper(".testimonials--carousel", {
  slidesPerView: 1,
  spaceBetween: 50,
  autoHeight: true,
  loop: true,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    769: {
      slidesPerView: 3,
    },
  },
});

 // Logo List Slider Section

 let logoListTestimonials = new Swiper(".logo-list--carousel", {
  slidesPerView: 1,
  spaceBetween: 50,
  loop: true,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 3,
    },
    769: {
      slidesPerView: 5,
      spaceBetween:100,
    },
  },
});

 // Image Slider Section

 let imageTestimonials = new Swiper(".image--carousel", {
  slidesPerView: 1,
  spaceBetween: 50,
  centeredSlides: true,
  loop: true,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 2,
      spaceBetween:10,
    },
    400: {
      slidesPerView: 2,
      spaceBetween:25,
    },
    769: {
      slidesPerView: 4,
      spaceBetween:50,
    },
  },
});

// Custom for 5SENS

 // Instagram Slider Section

 let insta = new Swiper(".insta-mobile", {
  slidesPerView: 2,
  spaceBetween: 0,
  loop: true,
  autoplay:true,
  autoHeight: true,
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    769: {
      slidesPerView: 2,
      spaceBetween:30,
    },
  },
});

 // Double Slider Section

 let double = new Swiper(".double-slider", {
  fadeEffect: { crossFade: true },
  effect: 'fade',
  autoplay: true,
  speed: 1000, 
  slidersPerView: 1
});

let doubleTwo = new Swiper(".double-slider-two", {
  fadeEffect: { crossFade: true },
  effect: 'fade',
  autoplay: true,
  speed: 1000, 
  slidersPerView: 1
});

console.log(doubleTwo);



// Accordion + & -

function changeIcon(anchor) {
  var icon = anchor.querySelector("i");
  icon.classList.toggle('ico-plus');
  icon.classList.toggle('ico-minus');
}


 // Custom BG Hover Section

 let customBGHover = new Swiper(".hover-bg-slider", {
  slidesPerView: 1,
  spaceBetween: 50,
  autoplay:true,
  loop:true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
  },
});


// Announcement Bar

// Selector

const navBar = document.querySelector('nav');

const announement = document.querySelector('.announcement-bar');

const wrapper = document.querySelector('#content--wrapper');

if(sessionStorage.getItem('announcement') === 'hidden') {
  const barHeight = document.querySelector('.announcement-bar').offsetHeight;
  navBar.style.marginTop = `0px`;
  announement.style.marginTop = `-${barHeight}px`;
  wrapper.style.marginTop = '55px';
} else {
  const barHeight = document.querySelector('.announcement-bar').offsetHeight;
  console.log(barHeight);
  document.querySelector('nav').style.marginTop = `${barHeight}px`;
}

// Handle Close Announcement

function hideAnnouncement() {
  const barHeight = document.querySelector('.announcement-bar').offsetHeight;
  navBar.style.marginTop = `0px`;
  announement.style.marginTop = `-${barHeight}px`;
  wrapper.style.marginTop = '55px';
  sessionStorage.setItem('announcement', 'hidden');
}
